import { AppLabel, AppText, Button, CustomContainer, FixedContainer, FlexColumn, FlexRow, SidePopupContainer } from "src/style"


export const DisplayBox: React.FC<any> = ({title, text, btnText, action, children, close}) => {

    function handleAction () {
        if (action) action()
        close()
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FixedContainer 
                className="display-box-container" 
                zIndex="9" radius="0.8" bgColor="#ffffff"
                topPadding="1.5"
            >
                <FlexColumn 
                    width="51" minHeight="26" padding="2.5"
                    radius="0.8" bgColor="#ffffff"
                >
                    <CustomContainer>
                        { !children ?
                            <>
                                <AppLabel 
                                    textSize="2" fontWeight="600" color="#27272E" align="center" 
                                    style={{display: 'block'}}
                                >
                                    {title}
                                </AppLabel>
                                <AppText align="center" width="36" topMargin="1"
                                    style={{marginLeft: 'auto', marginRight: 'auto'}}
                                >
                                    {text}
                                </AppText>
                                <FlexRow justifyContent="center" topMargin="4">
                                    <Button
                                        width='11' borderColor='#4C6FFF' height='4.6'
                                        hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                                        radius="0.8"
                                        onClick={handleAction}
                                    >
                                        {btnText || 'Continue'}
                                    </Button>
                                </FlexRow>
                            </>
                            : children
                        }
                    </CustomContainer>
                </FlexColumn>
            </FixedContainer>
        </>
    )
}